export enum CommentType {
    Appliaction = 0,
    Insurance = 1
}